import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import pick from 'lodash/pick';
import RepVisitsYourSchedule from './repvisits-your-schedule';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query RepVisitsYourSchedule($fromDateOrdinal: OrdinalDate!, $toDateOrdinal: OrdinalDate!) {
    viewer {
      id
      enabledFeatures
      repVisitsSchedule(fromDate: $fromDateOrdinal, toDate: $toDateOrdinal) {
        id
        date
        appointments {
          collegeFairId
          appointmentId
          id
          userBookingStatus
          chosenVisitLocationType
          visitLocationType
          highSchool {
            name
            id
          }
          startTime
          endTime
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ params }) => {
    const variables = pick(params, ['fromDate', 'fromDateOrdinal', 'toDate', 'filter', 'toDateOrdinal']);
    return {
      variables,
    };
  },
});
export default SimpleLoadingComponent(graphqlData)(RepVisitsYourSchedule);
